import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from "@/views/Auth/LoginView";
import HomeView from "@/views/Main/HomeView";

import CategoriesList from "@/views/Category/CategoriesList";
import CreateCategory from "@/views/Category/CreateCategory";
import UpdateCategory from "@/views/Category/UpdateCategory";

import ProductList from "@/views/Product/ProductList";
import CreateProduct from "@/views/Product/CreateProduct";
import UpdateProduct from "@/views/Product/UpdateProduct";

import SpecificationList from "@/views/Specification/SpecificationList";
import CreateSpecification from "@/views/Specification/CreateSpecification";
import UpdateSpecification from "@/views/Specification/UpdateSpecification";

import AdminsList from "@/views/Admin/AdminsList";
import CreateAdmin from "@/views/Admin/CreateAdmin";
import UpdateAdmin from "@/views/Admin/UpdateAdmin";

import CustomersList from "@/views/Customer/CustomersList";
import CreateCustomer from "@/views/Customer/CreateCustomer";
import UpdateCustomer from "@/views/Customer/UpdateCustomer";

import PostsList from "@/views/Post/PostsList";
import CreatePost from "@/views/Post/CreatePost";
import UpdatePost from "@/views/Post/UpdatePost";
import PostComments from "@/views/Post/PostComments";

import MessagesList from "@/views/Message/MessagesList";

import ProfileView from "@/views/Profile/ProfileView"

import OrderList from "@/views/Order/OrderList";

import ContactUs from "@/views/Setting/ContactUs";
import AboutUs from "@/views/Setting/AboutUs.vue";
import FooterSetting from "@/views/Setting/FooterSetting.vue";
import HomePageSetting from "@/views/Setting/HomePageSetting.vue";
import SeoSetting from "@/views/Setting/SeoSetting.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/categories',
    name: 'categories-list',
    component: CategoriesList
  },
  {
    path: '/categories/create',
    name: 'create-category',
    component: CreateCategory
  },
  {
    path: '/categories/update/:fa_slug',
    name: 'update-category',
    component: UpdateCategory
  },
  {
    path: '/products',
    name: 'products-list',
    component: ProductList
  },
  {
    path: '/products/create',
    name: 'create-product',
    component: CreateProduct
  },
  {
    path: '/products/update/:fa_slug',
    name: 'update-product',
    component: UpdateProduct
  },
  {
    path: '/specifications',
    name: 'specifications-list',
    component: SpecificationList
  },
  {
    path: '/specifications/create',
    name: 'create-specification',
    component: CreateSpecification
  },
  {
    path: '/specifications/update/:id',
    name: 'update-specification',
    component: UpdateSpecification
  },
  {
    path: '/orders',
    name: 'orders-list',
    component: OrderList
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView
  },
  {
    path: '/admins',
    name: 'admins-list',
    component: AdminsList
  },
  {
    path: '/admins/create',
    name: 'create-admin',
    component: CreateAdmin
  },
  {
    path: '/admins/update/:id',
    name: 'update-admin',
    component: UpdateAdmin
  },
  {
    path: '/customers',
    name: 'customers-list',
    component: CustomersList
  },
  {
    path: '/customers/create',
    name: 'create-customer',
    component: CreateCustomer
  },
  {
    path: '/customers/update/:id',
    name: 'update-customer',
    component: UpdateCustomer
  },
  {
    path: '/posts',
    name: 'posts-list',
    component: PostsList
  },
  {
    path: '/posts/create',
    name: 'create-post',
    component: CreatePost
  },
  {
    path: '/posts/update/:fa_slug',
    name: 'update-post',
    component: UpdatePost
  },
  {
    path: '/posts/comments/:fa_slug',
    name: 'post-comments',
    component: PostComments
  },
  {
    path: '/messages',
    name: 'messages-list',
    component: MessagesList
  },
  {
    path: '/settings/contact_us',
    name: 'contact-us',
    component: ContactUs
  },
  {
    path: '/settings/about_us',
    name: 'about-us',
    component: AboutUs
  },
  {
    path: '/settings/footer',
    name: 'footer',
    component: FooterSetting
  },
  {
    path: '/settings/home_page',
    name: 'home_page',
    component: HomePageSetting
  },
  {
    path: '/settings/seo',
    name: 'seo',
    component: SeoSetting
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
